module.exports = __webpack_public_path__ + "img/star.daeda691.svg";